var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImgAllFlame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.9037 65.1883C98.4055 89.0678 79.4284 105.518 58.9528 104.988C35.4881 104.379 20 82.7 20 64.6576C20 50.8606 24.1873 43.962 26.4922 39.7168C31.7325 30.0649 34.5542 23.9027 35.6254 21.0882C35.8309 20.5482 36.4385 20.2584 36.9263 20.568C40.8837 23.0794 44.9454 31.4282 46.7623 36.0076C46.8917 36.3338 47.2052 36.5755 47.4942 36.3764C49.9733 34.6684 54.6257 20.0067 57.0824 11.3293C57.2682 10.6729 58.036 10.3936 58.5665 10.8226C67.4136 17.9752 73.0548 37.0424 75.9324 36.5328C78.056 36.1567 80.2058 27.5619 81.4789 22.4081C81.6696 21.6358 82.6387 21.3956 83.1642 21.9928C96.9313 37.6405 100.678 52.8433 99.9037 65.1883Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImgAllFlame);
export default __webpack_public_path__ + "static/media/iconImgAllFlame.32ac6bfb6dd3a9f3be7904ff490ec25b.svg";
export { ForwardRef as ReactComponent };